module.exports = __webpack_public_path__ + "static/media/icon-edit.3d872ce9.svg";